import { useTranslation } from 'react-i18next';
import { FaBriefcase, FaUserGraduate } from 'react-icons/fa';

export const Achivements = ({ achievements }) => {
  const { t } = useTranslation();
  return (
    <section className="mt-2">
      <div className="container">
        <div className="row d-flex align-items-stretch">
          <div className="col-md-6 col-lg-4 mb-4">
            <div className="number-wrapper d-flex align-items-center">
              <div className=" p-3 rounded-circle" style={{ backgroundColor: 'rgb(136, 36, 46)' }}>
                <FaUserGraduate className="text-white display-5" />
              </div>

              <div className="text ms-4">
                <p className="m-0 fs-1 fw-bold">{achievements?.userAmount}+</p>
                <span className="opacity-50">{t('All students one cruit')}</span>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 mb-4">
            <div className="number-wrapper d-flex align-items-center">
              <div className=" p-3 rounded-circle" style={{ backgroundColor: 'rgb(136, 36, 46)' }}>
                <FaUserGraduate style={{ color: 'black' }} className="text-white display-5" />
              </div>

              <div className="text ms-4">
                <p className="m-0 fs-1 fw-bold">{achievements?.userInDay}+</p>
                <span className="opacity-50">{t('Students in one day')}</span>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4 mb-4">
            <div className="number-wrapper d-flex align-items-center">
              <div className=" p-3 rounded-circle" style={{ backgroundColor: 'rgb(136, 36, 46)' }}>
                <FaBriefcase className="text-white display-5" />
              </div>

              <div className="text ms-4">
                <p className="m-1 fs-1 fw-bold">{achievements?.companyAmount}+</p>
                <span className="opacity-50">{t('All companies with us')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
